import { render, staticRenderFns } from "./new-level.vue?vue&type=template&id=bc5326c8"
import script from "./new-level.vue?vue&type=script&lang=js"
export * from "./new-level.vue?vue&type=script&lang=js"
import style0 from "./new-level.vue?vue&type=style&index=0&id=bc5326c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports